// Create a new config file for the client
const config = {
    apiUrl: import.meta.env.PROD
        ? 'https://explainyourlabs.com/api'
        : 'http://localhost:3000/api'
};

export default config; 